define.alias("shared/components/shared/card/container", "calendar/components/shared/card/container");